import {
  getBrigade,
  getOneBrigade,
  createBrigade,
  updatePatchBrigade,
  updatePutBrigade,
  deleteBrigade,
} from '@/api/reference'

export default {
  CREATE_BRIGADE(_, data) {
    return createBrigade(data)
  },
  FETCH_BRIGADE({ commit }, params) {
    return getBrigade(params)
      .then(res => {
        commit('SET_BRIGADE', res.data)
      })
  },
  FETCH_ONE_BRIGADE({ commit }, params) {
    return getOneBrigade(params)
      .then(res => {
        commit('SET_ONE_BRIGADE', res.data)
      })
  },
  UPDATE_PATCH_BRIGADE(_, data) {
    return updatePatchBrigade(data)
  },
  UPDATE_PUT_BRIGADE(_, data) {
    return updatePutBrigade(data)
  },
  DELETE_BRIGADE(_, id) {
    return deleteBrigade(id)
  },
}
